import Vue from 'vue';
import TheLogo from '@/components/TheLogo.vue';
import BaseBreadcrumb from '@/components/BaseBreadcrumb.vue';
import BaseTable from '@/components/BaseTable.vue';
import BaseLoading from '@/components/BaseLoading.vue';
import BaseDropDown from '@/components/BaseDropDown.vue';
import BaseSwitch from '@/components/BaseSwitch.vue';
import BaseActionBar from '@/components/BaseActionBar.vue';
import BaseActionSubmit from '@/components/BaseActionSubmit.vue';
import BaseSearchFilter from '@/components/BaseSearchFilter.vue';
import BaseSearchFormFooter from '@/components/BaseSearchFormFooter.vue';
import BaseModalConfirm from '@/components/BaseModalConfirm.vue';
import BaseFilterButton from '@/components/BaseFilterButton.vue';
import TheToastContainer from '@/components/TheToastContainer.vue';
import ToastBox from '@/components/ToastBox.vue';
import BaseTabBar from '@/components/BaseTabBar.vue';
import StockBrowserSkuList from '@/views/StockBrowserSkuList.vue';
import StockBrowserBranchList from '@/views/StockBrowserBranchList.vue';
import BaseInputNumber from '@/components/BaseInputNumber.vue';
import BaseInputDate from '@/components/BaseInputDate.vue';
import ModalCategory from '@/components/ModalCategory.vue';
import ModalSku from '@/components/ModalSku.vue';
import ModalBranch from '@/components/ModalBranch.vue';
import ModalCondition from '@/components/ModalCondition.vue';
import ModalConfirmDelete from '@/components/ModalConfirmDelete.vue';
import ModalConfirmUpdateOrderStatus from '@/components/ModalConfirmUpdateOrderStatus.vue';
import ModalHeaderWrapper from '@/components/ModalHeaderWrapper.vue';
import ModalResolvedIssue from '@/components/ModalResolvedIssue.vue';
import BaseModalFooter from '@/components/BaseModalFooter.vue';
import BaseModalLoading from '@/components/BaseModalLoading.vue';
import CategorySelectList from '@/components/CategorySelectList.vue';
import CategorySelectListItem from '@/components/CategorySelectListItem.vue';
import MultipleSelect from '@/components/MultipleSelect.vue';
import BaseNoItemBanner from '@/components/BaseNoItemBanner.vue';
import AllocationOnlineGroupList from '@/views/AllocationOnlineGroupList.vue';
import ErrorOpenedIssue from '@/views/ErrorOpenedIssue.vue';
import ErrorResolvedIssue from '@/views/ErrorResolvedIssue.vue';

import router from './router';
import store from './store';
import i18n from './plugins/i18n';
import icons from './assets/icons';
import App from './App.vue';
import requiredAuth from './middleware/requiredAuth';

// import plugins
import './plugins/vue3';
import './plugins/coreui';
import './plugins/fontawesome';
import './plugins/vuelidate';
import './plugins/filter';
import './plugins/htmlToPaper';

// import scss
import './assets/scss/style.scss';

// internal components, set as to global
Vue.component('TheLogo', TheLogo);
Vue.component('BaseBreadcrumb', BaseBreadcrumb);
Vue.component('BaseTable', BaseTable);
Vue.component('BaseLoading', BaseLoading);
Vue.component('BaseDropDown', BaseDropDown);
Vue.component('BaseSwitch', BaseSwitch);
Vue.component('BaseActionBar', BaseActionBar);
Vue.component('BaseActionSubmit', BaseActionSubmit);
Vue.component('BaseSearchFilter', BaseSearchFilter);
Vue.component('BaseModalConfirm', BaseModalConfirm);
Vue.component('BaseFilterButton', BaseFilterButton);
Vue.component('BaseSearchFormFooter', BaseSearchFormFooter);
Vue.component('TheToastContainer', TheToastContainer);
Vue.component('ToastBox', ToastBox);
Vue.component('BaseTabBar', BaseTabBar);
Vue.component('StockBrowserSkuList', StockBrowserSkuList);
Vue.component('StockBrowserBranchList', StockBrowserBranchList);
Vue.component('BaseInputNumber', BaseInputNumber);
Vue.component('BaseInputDate', BaseInputDate);
Vue.component('ModalCategory', ModalCategory);
Vue.component('ModalSku', ModalSku);
Vue.component('ModalBranch', ModalBranch);
Vue.component('ModalCondition', ModalCondition);
Vue.component('ModalConfirmDelete', ModalConfirmDelete);
Vue.component('ModalConfirmUpdateOrderStatus', ModalConfirmUpdateOrderStatus);
Vue.component('ModalHeaderWrapper', ModalHeaderWrapper);
Vue.component('ModalResolvedIssue', ModalResolvedIssue);
Vue.component('BaseModalFooter', BaseModalFooter);
Vue.component('BaseModalLoading', BaseModalLoading);
Vue.component('CategorySelectList', CategorySelectList);
Vue.component('CategorySelectListItem', CategorySelectListItem);
Vue.component('MultipleSelect', MultipleSelect);
Vue.component('BaseNoItemBanner', BaseNoItemBanner);
Vue.component('AllocationOnlineGroupList', AllocationOnlineGroupList);
Vue.component('ErrorOpenedIssue', ErrorOpenedIssue);
Vue.component('ErrorResolvedIssue', ErrorResolvedIssue);

// middleware required logged in
router.beforeEach(requiredAuth(store));

new Vue({
	router,
	store,
	i18n,
	icons,
	render: (h) => h(App),
}).$mount('#app');
